import _ from 'underscore';

export default {
  fnAjaxRequest: function(
    ajaxURL,
    ajaxReqMethod,
    ajaxReqData,
    onSuccess,
    onError
  ) {
    try {
      $.ajax({
        type: ajaxReqMethod,
        url: ajaxURL,
        data: ajaxReqData,
        success: onSuccess,
        error: onError,
        contentType: 'application/x-www-form-urlencoded'
      });
    } catch (ex) {
      // console.log('a')
    }
  },

  ShowVSAlert: function(type, message) {
    var alertType = type || 'info';
    var alertMessage = message || '';
    $('.warning-icon').addClass('hide');
    $('.error-icon').addClass('hide');
    $('.success-icon').addClass('hide');
    if (alertType == 'info') {
      $('.warning-icon').removeClass('hide');
    } else if (alertType == 'error') {
      $('.error-icon').removeClass('hide');
    } else {
      $('.success-icon').removeClass('hide');
    }
    $('.alert-body .alert-text').html(alertMessage);
    $('.vsCodeAlert').fadeIn(function() {
      setTimeout(() => {
        $('.vsCodeAlert').fadeOut();
      }, 3000);
    });
  },

  merge_object_arrays: function(arr1, arr2, match) {
    return _.union(
      _.map(arr1, function(obj1) {
        var same = _.find(arr2, function(obj2) {
          return obj1[match] === obj2[match];
        });
        return same ? _.extend(obj1, same) : obj1;
      }),
      _.reject(arr2, function(obj2) {
        return _.find(arr1, function(obj1) {
          return obj2[match] === obj1[match];
        });
      })
    );
  },

  showLoader: function() {
    $('.component-loader').removeClass('hide');
  },

  hideLoader: function() {
    $('.studio-loader').hide();
    $('.component-loader').addClass('hide');
  }
};
